import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../../constants";
import Icon from "../../components/general/icon";
import SearchBox from "../../components/general/searchBox";
import DeleteOrganizationModal from "../../components/organization/deleteOrganizationModal";
import { useWindowSize } from "../../../hook/useWindowSize";
import OrganizationTable from "../../components/organization/dataList/organizationTable";
import OrganizationCardsBox from "../../components/organization/dataList/organizationCardsBox";
import { useGetOrganizations } from "../../../hook/request/organizations";
import { useMySearchParams } from "../../../hook/useMySearchParams";
import Pagination from "../../components/general/table/pagination";
import {useFindAccessInAccessList} from "../../../constants/constant/accessProcess";

const dataListTitles = [
  "نام مرکز",
  "شماره تلفن",
  // "نام مدیریت",
  "آدرس",
  "تاریخ ایجاد",
  "مراکز متصل",
  "عملیات",
]

type TFilterValues = {
  pageNumber?: string;
  perPage?: string;
  search?: string;
}

const OrganizationsList = () => {

  const [width] = useWindowSize();
  const {findAccessInAccessList} = useFindAccessInAccessList();
  const [searchParams] = useSearchParams();
  const { getQueryParams, updateSearchParams } = useMySearchParams();
  const [organizationsData, setOrganizationsData] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    pageNumber: "0",
    perPage: "10",
    search: "",
  });

  // services
  const getOrganizationsRequest = useGetOrganizations(getQueryParams(filterValues));

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || ""
    }
    setFilterValues(_filterValues)
  }, [searchParams]);

  useEffect(() => {
    getOrganizationsRequest?.data?.data?.result &&
      setOrganizationsData(getOrganizationsRequest?.data?.data.result)
  }, [getOrganizationsRequest.data])

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateSearchParams({
      pageNumber: "0",
      perPage: filterValues?.perPage,
      [name]: value,
    })
  }

  const doChangePage = (param: any) => {
    updateSearchParams({
      pageNumber: param?.index,
      perPage: filterValues?.perPage,
    })
  }

  return (
    <>
      <div className="card-box">
        <section className="filter-box d-flex flex-column flex-md-row mb-4">
          <div className="form-group ms-md-auto">
            <SearchBox
              name="search"
              value={filterValues?.search}
              onChange={handleFilterChange}
              placeholder="جستجوی مرکز درمانی"
            />
          </div>
          {
            findAccessInAccessList('HEALTH_ORGANIZATION_CREATE') &&
            <div className="d-flex align-items-center align-items-stretch justify-content-center justify-content-md-start mb-3 m-md-0">
              <Link to={ROUTES.ORGANIZATION_ADD.PATH} className="btn btn-primary rounded d-flex align-items-center fw-bold px-4">
                <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="add-square"/></span>
                افزودن مرکز درمانی
              </Link>
            </div>
          }
        </section>

        <section className="table-cont table-responsive">
          {
            width < 900 ?
              <OrganizationCardsBox
                dataList={organizationsData}
                dataListTitles={dataListTitles}
                isRequesting={getOrganizationsRequest.isPending}
              /> :
              <OrganizationTable
                dataList={organizationsData}
                dataListTitles={dataListTitles}
                isRequesting={getOrganizationsRequest.isPending}
              />
          }
          <Pagination
            paginationData={{...filterValues, ...organizationsData}}
            doChangePage={doChangePage}
          />
        </section>
      </div>
      
      <DeleteOrganizationModal />
    </>
  );
};

export default OrganizationsList;